import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loadingSubject = new BehaviorSubject<{ loading: boolean, loaded: boolean }>({ loading: false, loaded: false });
  public loading$ = this.loadingSubject.asObservable();

  show() {
   
    this.loadingSubject.next({ loading: true, loaded: false });
  }

  hide() {
    
    this.loadingSubject.next({ loading: false, loaded: true });
  }
}
